module.exports = __webpack_public_path__ + "static/Instant Financial-552eea24aeeccbeefef9beb9606b316e.jpg";